export default __webpack_public_path__ + "static/media/suti_tajekoztato.0fdd81a9.pdf";